import React from 'react';
import CardLoader from 'components/loader/CardLoader';

const UICard = (props) => {

    const {
        header = false,
        CardBody = false,
        loading = false,
        jsx = false,
        customClasses = '',
        customHeaderClasses = ''
    } = props

    return (
        <>
            <div className={`card custom-card shadow-sm ${customClasses}`}>
                {header ? <div className={`card-header custom-card-header ${customHeaderClasses}`}>
                    {header}
                </div> : null}
                <div className="card-body">
                    {loading ? <CardLoader /> : null}
                    {!loading && CardBody && !jsx ? <CardBody /> : null}
                    {!loading && CardBody && jsx ? CardBody : null}
                </div>
            </div>
        </>
    )
}

export default UICard